import CssBaseline from '@mui/material/CssBaseline';

const GlobalStyles = (): React.ReactElement => (
  <>
    <CssBaseline />
  </>
);

export { GlobalStyles };
